import React from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import copyToClipboard from 'copy-to-clipboard'

import IconChevronRight from 'client/icons/ChevronRight'
import IconInstagram from 'client/icons/social/Instagram'

import { addError } from 'src/utils/clientErrorReporter'
import { usePage } from 'src/hooks/usePage'
import { useKafkaEvent } from 'src/hooks/useKafkaEvent'
import { SECTIONS } from 'src/hooks/useKafkaEvent/constants'
import { useDevice } from 'src/hooks/useDevice'
import { Devices } from 'src/types/device'
import { displayAlertAction } from 'src/comps/AlertMessage/actions'

import styles from './styles.module.css'

interface ShareCopyProps {
  propertyId: number
}

const INSTAGRAM_APP_URL = 'instagram://direct'

const ShareInstagram = ({ propertyId }: ShareCopyProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const { pageId } = usePage()
  const { sendEvent } = useKafkaEvent({ page: pageId, eventName: 'click' })
  const { device } = useDevice()

  if (device !== Devices.Mobile) {
    return null
  }

  const handleClick = () => {
    const currentUrl = new URL(window.location.href)
    if (currentUrl.pathname === '/hotel/[country]/[slug]') {
      addError(new Error('[Copy Link] Bad URL'))
    }

    sendEvent(
      { section: SECTIONS.SHARE_MODAL_OPTION },
      {
        option: 'instagram',
        propertyId,
      }
    )

    const shareMessage = `${intl.formatMessage({
      id: 'share.on-instagram-msg',
    })} ${window.location.href}`

    copyToClipboard(shareMessage)

    dispatch(
      displayAlertAction({
        title: intl.formatMessage({
          id: 'notification.success-share-ig-title',
        }),
        description: intl.formatMessage({
          id: 'notification.success-share-ig-body',
        }),
        severity: 'success',
      })
    )

    window.location.href = INSTAGRAM_APP_URL
  }

  return (
    <li>
      <button
        type="button"
        className={styles.button}
        data-testid="share-instagram"
        onClick={handleClick}
        aria-label={intl.formatMessage({ id: 'share.on-instagram' })}
      >
        <IconInstagram />
        <p>{intl.formatMessage({ id: 'share.on-instagram' })}</p>
        <IconChevronRight />
      </button>
    </li>
  )
}

export default ShareInstagram
